module.exports = __webpack_public_path__ + "img/icon_account_white.6acca1cf.svg";